import { HIDE_PAYMENT_KASPI_ID } from '../constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export const useHidePaymentKaspi = () => {
  return useHideSomeExperiment(HIDE_PAYMENT_KASPI_ID);
};
